export interface ToolCopy {
  labelKey: string;
  detailKey: string;
}

const TOOL_COPY: Readonly<Record<string, ToolCopy>> = {
  submit_form_for_signing: {
    labelKey: "intelligence.tools.submitForSigning.label",
    detailKey: "intelligence.tools.submitForSigning.detail",
  },
  cancel_form_signing: {
    labelKey: "intelligence.tools.cancelSigning.label",
    detailKey: "intelligence.tools.cancelSigning.detail",
  },
  delete_form: {
    labelKey: "intelligence.tools.deleteForm.label",
    detailKey: "intelligence.tools.deleteForm.detail",
  },
  end_client_relationship: {
    labelKey: "intelligence.tools.endClientRelationship.label",
    detailKey: "intelligence.tools.endClientRelationship.detail",
  },
  delete_client: {
    labelKey: "intelligence.tools.deleteClient.label",
    detailKey: "intelligence.tools.deleteClient.detail",
  },
  update_client: {
    labelKey: "intelligence.tools.updateClient.label",
    detailKey: "intelligence.tools.updateClient.detail",
  },
  create_portfolio: {
    labelKey: "intelligence.tools.createPortfolio.label",
    detailKey: "intelligence.tools.createPortfolio.detail",
  },
  approve_suggested_portfolio: {
    labelKey: "intelligence.tools.approveSuggestion.label",
    detailKey: "intelligence.tools.approveSuggestion.detail",
  },
  delete_suggested_portfolio: {
    labelKey: "intelligence.tools.deleteSuggestion.label",
    detailKey: "intelligence.tools.deleteSuggestion.detail",
  },
};

export function toolCopy(toolName: string | null): ToolCopy | null {
  if (!toolName) return null;
  return TOOL_COPY[toolName] ?? null;
}

export function hasArguments(argsText: string | null): boolean {
  if (!argsText) return false;
  const text = argsText.trim();
  return text !== "" && text !== "{}" && text !== "[]" && text !== "null";
}
